import ReactSpeedometer from "react-d3-speedometer"
let currentTemp;
export function TemperatureMeter({OilTemp}) {

   
    currentTemp= OilTemp[OilTemp.length-1].oilTemp;
    return (

        tempComponent(20)
    )

}

const tempComponent = (temp) => (
  
        <ReactSpeedometer
            width={250}
            height={190}
            ringWidth={20}
            needleHeightRatio={0.7}
            forceRender={false}
            maxSegmentLabels={1}
            customSegmentStops={[-20,0,20,40,60,80,100,120]}
            segmentColors={['#ffd54f', '#9ccc65','#9ccc65','#9ccc65','#9ccc65','#ffd54f','#ff8f00']}
            needleColor={'white'}
            currentValueText={'${value}\u00B0'}
            minValue={-20}
            maxValue={120}
            value={temp}
            textColor={"white"}
        />
    

)
const textColor = '#AAA'
const tempComponent2 = (temp) =>(

    <div>
    <ReactSpeedometer
    needleHeightRatio={0.7}
    maxSegmentLabels={5}
    segments={5555}
    value={temp}
    textColor={textColor}
    />
   </div>
    )
